import { atom } from 'jotai'

import { gridStateAtomFamily } from './gridStateFamilyAtom'

export const setColumnWidthAtom = atom<null, { id: string; field: string; width: number }>(
  null,
  (get, set, { id, field, width }) => {
    const gridStateAtom = gridStateAtomFamily(id)

    const prev = get(gridStateAtom)

    set(gridStateAtom, {
      ...prev,
      widths: {
        ...prev.widths,
        [field]: width,
      },
    })
  },
)
